import React from "react";
import { Container, Row, Col } from "reactstrap";

import RiskScoreCard from "./RiskScoreCard";
import AssetSecurityPosture from "./AssetSecurityPosture";
import AttackIndicators from "./AttackIndicators";
import ICSVulnerabilityMonitoring from "./ICSVulnerabilityMonitoring.js";
import NetworkSecurityAnomalies from "./NetworkSecurityAnomalies.js";
import ICSProtocolThreatDetection from "./ICSProtocolThreatDetection.js";
import AuthenticationAccess from "./AuthenticationAcess.js";
import ConfigurationIntegrity from "./ConfigurationIntegrity.js";
import MalwareOTThreatDetection from "./MalwareOTThreatDetection";
import SupplyChainRisk from "./SupplyChainRisk";
import OTSecurityAlertsFeed from "./OTSecurityAlertsFeed";

const pageHeadingStyle = {
  color: "var(--vz-body-color)",
};


const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};


const OTSecurityDashboard = () => {
  return (
    <div className="page-content">
      <Container fluid>

        {/* Page Title */}
        <Row className="mb-4">
          <Col>
            <h4 className="mb-0" style={pageHeadingStyle}>
              <div style={pageIconWrapStyle } className="me-2">
                <i className="ri-dashboard-line" style={pageIconStyle}></i>
              </div>
              OT Security Dashboard
            </h4>
          </Col>
        </Row>

        {/* Top Section */}
        <Row className="g-4 mb-4">
          <Col xl={4}>
            <RiskScoreCard />
          </Col>

          <Col xl={4}>
            <AssetSecurityPosture />
          </Col>

          <Col xl={4}>
            <AttackIndicators />
          </Col>
        </Row>

        {/* Second Section */}
        <Row className="g-4">
          <Col xl={7}>
            <ICSVulnerabilityMonitoring />
          </Col>

          <Col xl={5}>
            <NetworkSecurityAnomalies />
          </Col>
        </Row>

        {/* Thirdt Section */}

        <Row className="g-4 mt-1">

          <Col xl={4}>
            <ICSProtocolThreatDetection />
          </Col>

          <Col xl={4}>
            <AuthenticationAccess />
          </Col>

          <Col xl={4}>
            <ConfigurationIntegrity />
          </Col>

        </Row>

        {/* Fourth Section */}
        <Row className="g-4 mt-1">

          <Col xl={6}>
            <MalwareOTThreatDetection />
          </Col>

          <Col xl={6}>
            <SupplyChainRisk />
          </Col>

        </Row>

        {/* Fifth Section */}

        <Row className="g-4 mt-1">
          <Col xl={12}>
            <OTSecurityAlertsFeed />
          </Col>
        </Row>



      </Container>
    </div>
  );
};

export default OTSecurityDashboard;